import { render, staticRenderFns } from "./FreeContent.vue?vue&type=template&id=c5e2dbd2"
import script from "./FreeContent.vue?vue&type=script&lang=js"
export * from "./FreeContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports